interface EmptyStateProps {
  totalSubscriptions: number;
  subscriptionsInPeriod: number;
  periodDisplay: string;
}

export const EmptyState = ({
  totalSubscriptions,
  subscriptionsInPeriod,
  periodDisplay,
}: EmptyStateProps) => {
  const getEmptyStateContent = () => {
    if (totalSubscriptions === 0) {
      return {
        title: "No subscriptions yet",
        description:
          "Add your first subscription to get started tracking your recurring payments.",
      };
    } else if (subscriptionsInPeriod === 0) {
      return {
        title: `No subscriptions due in ${periodDisplay}`,
        description:
          "Try selecting a different month or add subscriptions that have payments due in this period.",
      };
    } else {
      return {
        title: "No subscriptions match your filters",
        description: "Try adjusting your search or filter criteria.",
      };
    }
  };

  const content = getEmptyStateContent();

  return (
    <div className="glass-card p-12 text-center">
      <div className="mb-4 text-6xl">📱</div>
      <h3 className="mb-2 text-xl font-semibold">{content.title}</h3>
      <p className="mb-6 text-muted-foreground">{content.description}</p>
    </div>
  );
};

EmptyState.displayName = "EmptyState";
